<template>
  <nav class="nav-bar-mobile" :class="`nav-bar-mobile--${$store.state.navBarStatus}`">
    <div class="nav-bar-mobile__left-ctn">
      <div class="back-btn mr-1" @click="goToMobilePage">
        <font-awesome-icon icon="arrow-left" />
      </div>
      <div id="nav-bar-mobile-logo" class="nav-bar-mobile__logo" :class="{'nav-bar-mobile__logo--large' : isMenuVisible}" @click="goToHomePage">
        <img src="@/assets/images/onesti-logo/onesti.svg" alt="Logotipo Onesti">
      </div>
    </div>
    <div ref="menu-btn" class="nav-bar-mobile__menu-btn" :class="{'nav-bar-mobile__menu-btn--close' : isMenuVisible}" @click="toggleMenu">
      <font-awesome-icon v-if="isMenuVisible" icon="times" />
      <font-awesome-icon v-else icon="bars" />
    </div>
    <div id="nav-bar-mobile-menu" class="nav-bar-mobile-menu" :class="{'nav-bar-mobile-menu--visible' : isMenuVisible}">
      <div class="nav-bar-mobile-menu__wrapper">
        <div class="language-ctn mt-8">
          <div class="language-options">
            <div class="language-item" :class="{'language-item--selected' : currentLocale === 'pt'}" @click="changeLanguage('pt')">
              Português
            </div>
            <div class="language-item" :class="{'language-item--selected' : currentLocale === 'es'}" @click="changeLanguage('es')">
              Español
            </div>
            <div class="language-item" :class="{'language-item--selected' : currentLocale === 'en'}" @click="changeLanguage('en')">
              English
            </div>
            <div class="language-item" :class="{'language-item--selected' : currentLocale === 'cn'}" @click="changeLanguage('cn')">
              中国
            </div>
          </div>
        </div>
        <div class="divider" />
        <div v-if="!isInPageOtherThanHome" class="nav-bar-mobile-menu__drawer">
          <div ref="first-option" class="mobile-menu-item" data-name="office" @click.self="toggleSubMenu">
            <span class="mobile-menu-item__title">
              {{ $t('navBar.menuTitle.office') }}
            </span>
            <ul class="mobile-menu-item__submenu"
                :class="{'mobile-menu-item__submenu--visible' : openedSubMenu === 'office'}"
            >
              <li v-for="(subMenuItems, index) in $t('navBar.subMenu.office')"
                  class="menu-link"
                  :data-to="officeSubMenuNames[index]"
                  @click="goToSection"
              >
                <span v-for="subMenu in subMenuItems">
                  {{ subMenu }}
                </span>
              </li>
            </ul>
          </div>
          <div class="mobile-menu-item" data-name="practice" @click.self="toggleSubMenu">
            <span class="mobile-menu-item__title">{{ $t('navBar.menuTitle.practice') }}</span>
            <ul class="mobile-menu-item__submenu"
                :class="{'mobile-menu-item__submenu--visible' : openedSubMenu === 'practice'}"
            >
              <li v-for="(subMenuItems, index) in $t('navBar.subMenu.practice')"
                  class="menu-link"
                  :data-to="practiceSubMenuNames[index]"
                  @click="goToSection"
              >
                <span v-for="subMenu in subMenuItems">
                  {{ subMenu }}
                </span>
              </li>
            </ul>
          </div>
          <div class="mobile-menu-item" data-name="recognition" @click.self="toggleSubMenu">
            <span class="mobile-menu-item__title">{{ $t('navBar.menuTitle.recognition') }}</span>
            <ul class="mobile-menu-item__submenu" :class="{'mobile-menu-item__submenu--visible' : openedSubMenu === 'recognition'}">
              <li v-for="(subMenuItems, index) in $t('navBar.subMenu.recognition')"
                  class="menu-link"
                  :data-to="recognitionSubMenuNames[index]"
                  @click="goToSection"
              >
                <span v-for="subMenu in subMenuItems">
                  {{ subMenu }}
                </span>
              </li>
            </ul>
          </div>
          <div class="mobile-menu-item" data-name="socialMedia" @click.self="toggleSubMenu">
            <span class="mobile-menu-item__title">{{ $t('navBar.menuTitle.socialMedia') }}</span>
            <ul class="mobile-menu-item__submenu mobile-menu-item__submenu--social-media"
                :class="{'mobile-menu-item__submenu--visible' : openedSubMenu === 'socialMedia'}"
            >
              <li class="menu-link">
                <a href="https://www.facebook.com/Onestilaw/" target="_blank">Facebook</a>
              </li>
              <li class="menu-link">
                <a href="https://pt.linkedin.com/company/onestilaw" target="_blank">Linkedin</a>
              </li>
              <li class="menu-link">
                <a href="https://www.instagram.com/Onestilaw/" target="_blank">Instagram</a>
              </li>
              <li class="menu-link">
                <a href="https://x.com/Onestilaw/" target="_blank">X</a>
              </li>
              <li class="menu-link">
                <a href="https://www.youtube.com/onesti-advogados" target="_blank">Youtube</a>
              </li>
              <li class="menu-link">
                <a href="https://www.yelp.com.br/biz/onesti-advogados-s%C3%A3o-paulo-2" target="_blank">Yelp</a>
              </li>
            </ul>
          </div>
          <div ref="menu-indicator" class="mobile-menu-indicator" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { TweenLite } from 'gsap'
require('../../node_modules/gsap/ScrollToPlugin')

export default {
  name: 'NavBarMobile',
  data () {
    return {
      isMenuVisible: false,
      openedSubMenu: undefined,
      officeSubMenuNames: [
        'unique',
        'from',
        'see',
        'think',
        'live',
        'practice'
      ],
      practiceSubMenuNames: [
        'have',
        'ready',
        'solutions',
        'performance'
      ],
      menuIndicatorHeight: 24,
      menuIndicatorOffset: undefined,
      isMenuIndicatorReady: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    recognitionSubMenuNames () {
      return [
        'been',
        this.$i18n.locale === 'pt' ? 'testimony' : 'cases',
        this.$i18n.locale === 'pt' ? 'cases' : undefined
      ]
    },
    isInPageOtherThanHome () {
      const pagesName = ['modern-slavery-lang', 'green-politic-lang', 'general-politic-lang', 'anti-corruption-lang', 'legal-advice-lang']
      let result
      pagesName.every(page => {
        if (page === this.routeName) {
          result = true
          return false
        }
        return true
      })
      return result
    }
  },
  methods: {
    changeLanguage (lang) {
      this.isMenuVisible = false
      const currentRoute = this.$route.name
      let routeName
      if (currentRoute === 'root') routeName = 'home'
      else if (currentRoute.includes('lang')) routeName = currentRoute
      else routeName = currentRoute + '-lang'
      this.$router.push({
        name: routeName,
        params: {
          lang
        }
      })
      this.$store.dispatch('cleanAccordionsArr')
    },
    toggleMenu () {
      this.isMenuVisible = !this.isMenuVisible
    },
    toggleSubMenu ({ target }) {
      const subMenuName = target.getAttribute('data-name')
      if (this.openedSubMenu === subMenuName) this.openedSubMenu = undefined
      else {
        this.openedSubMenu = subMenuName
        setTimeout(() => {
          const selectedOptionTop = parseFloat(target.getBoundingClientRect().top).toFixed(2)
          const menuIndicator = this.$refs['menu-indicator']
          menuIndicator.style.transform = `translateY(${selectedOptionTop - this.menuIndicatorOffset}px)`
        }, 500)
      }
    },
    goToHomePage () {
      this.$router.push({ name: 'home' })
      this.$store.dispatch('changeMobileHomeVisibility', false)
    },
    goToMobilePage () {
      this.$store.dispatch('changeMobileHomeVisibility', true)
      window.scrollTo(0, 0)
    },
    goToSection ({ target }) {
      const sectionName = target.parentNode.getAttribute('data-to')
      TweenLite.to(window, 1, { scrollTo: `section[data-name=${sectionName}]`, autoKill: false })
      this.isMenuVisible = false
    },
    prepareMenuIndicator () {
      if (!this.isMenuIndicatorReady) {
        this.$nextTick(() => {
          const menuIndicator = this.$refs['menu-indicator']
          if (menuIndicator) {
            this.menuIndicatorOffset = parseFloat(menuIndicator.getBoundingClientRect().top).toFixed(2)
            this.isMenuIndicatorReady = true
          }
        })
      }
    }
  },
  watch: {
    isInLegalAdvicePage (val) {
      if (!val) this.prepareMenuIndicator()
    }
  },
  mounted () {
    this.prepareMenuIndicator()
    window.onresize = () => {
      this.menuIndicatorOffset = parseFloat(this.$refs['first-option'].getBoundingClientRect().top).toFixed(2)
    }
  },
  comments: true
}
</script>

<style scoped lang="sass">
/* purgecss start ignore */
@tailwind utilities

$item-menu-subtitle-divider-offset: 10px
$item-menu-subtitle-divider-height: 15px
$menu-easing: cubic-bezier(.54,.13,.6,.95)
$lateral-margin: 1.5rem

.nav-bar-mobile
  @apply fixed pin-t pin-l z-50 justify-between items-center w-full py-1 pr-2 pl-1
  background: rgba(0, 0, 0, 0.5)
  height: 40px
  &__left-ctn
    @apply flex items-center
  &__logo
    @apply relative z-70
    transition: transform .4s
    transform-origin: left top
    img
      width: 60px
    &--large
      transform: scale(2.5) translateY(7px) translateX(-10px)
  &__menu-btn
    @apply relative z-70 inline-flex justify-center items-center text-3xl text-white w-8 h-8
    transition: transform .4s
    &--close
      transform: translateY(40px)
  &--visible
    @apply flex
    @screen xl
      @apply hidden
  &--invisible
    @apply hidden

.language-ctn
  @apply text-center
  @screen sm-l
    @apply text-left
    margin-left: $lateral-margin
  @screen md
    @apply text-left
    margin-left: $lateral-margin

.language-options
  @apply inline-flex

.language-item
  @apply relative p-1 mr-1
  &--selected
    &::after
      @apply no-content absolute pin-b pin-l bg-white w-full h-px

.divider
  @apply bg-white opacity-25 h-px my-2
  margin-left: $lateral-margin
  margin-right: $lateral-margin

.nav-bar-mobile-menu
  @apply fixed z-60 pin-t pin-l -translate-y-100 bg-black text-white pointer-events-none overflow-hidden w-screen h-screen
  transition: transform .4s $menu-easing
  &__wrapper
    @apply translate-y-100 w-full h-full
    transition: transform .4s $menu-easing
  &__drawer
    @apply relative
    margin-left: $lateral-margin
    padding-left: $lateral-margin
    overflow-y: scroll
    @screen sm-l
      max-height: 170px
    &::before
      @apply no-content absolute pin-t bg-white w-px h-full
      left: 4px
  &--visible
    @apply translate-y-0 pointer-events-auto
    .nav-bar-mobile-menu
      &__wrapper
        @apply translate-y-0

.mobile-menu-item
  &__title
    @apply inline-flex items-center pointer-events-none h-8
  &__submenu
    @apply list-reset overflow-hidden ml-2
    max-height: 0
    transition: all .5s
    li
      span:first-child
        @apply relative
        margin-right: $item-menu-subtitle-divider-offset
        &::after
          @apply no-content absolute bg-white opacity-50 w-px
          bottom: 3px
          right: #{-$item-menu-subtitle-divider-offset}
          height: $item-menu-subtitle-divider-height
      span:last-child
        margin-left: $item-menu-subtitle-divider-offset
        color: #c2c2c2
    &--social-media
      li
        span:first-child
          &::after
            content: none
        span:last-child
          @apply text-white ml-0
    &--visible
      max-height: 500px

.menu-link
  @apply mt-1
  & > *
    @apply text-white no-underline
  padding: 0.2rem 0
  &:last-child
    @apply mb-2

.mobile-menu-indicator
  @apply absolute bg-white
  left: 3px
  top: 0
  width: 3px
  height: 32px
  transition: transform .4s

.back-btn
  @apply inline-flex items-center justify-center text-white text-xl w-8 h-8
/* purgecss end ignore */
</style>
